import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Main";
import Contact from "./pages/Contact";
import About from "./pages/About";
import News from "./pages/News";
import AdminLogin from "./pages/AdminLogin.jsx";

import Movies from "./pages/ProjectGrid";
import AdminDashboard from "./pages/AdminDashboard";
import Latest from "./pages/Latest";

import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import Footer from "./components/footer.jsx";
import ScrollToTop from "./components/ScrollToTop";
import { ToastProvider } from "./components/ui/ToastProvider";
import { ConfirmProvider } from "./components/ui/ConfirmProvider";

function Layout() {
  return (
    <Routes>
      {/* Public Pages WITH Navbar */}
      <Route
        path="/"
        element={
          <>
            <Navbar />
            <Home />
            <Footer />
          </>
        }
      />

      <Route
        path="/about-us"
        element={
          <>
            <Navbar />
            <About />
            <Footer />
          </>
        }
      />

      <Route
        path="/movies"
        element={
          <>
            <Navbar />
            <Movies />
            <Footer />
          </>
        }
      />

      <Route
        path="/contact"
        element={
          <>
            <Navbar />
            <Contact />
            <Footer />
          </>
        }
      />

      <Route
        path="/news"
        element={
          <>
            <Navbar />
            <News />
            <Footer />
          </>
        }
      />

      
      <Route
        path="/latest"
        element={
          <>
            <Navbar />
            <Latest />
            <Footer />
          </>
        }
      />

      {/* Admin Pages WITHOUT Navbar */}
      <Route path="/admin" element={<AdminLogin />} />

      <Route
        path="/admin-dashboard"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <ConfirmProvider>
          <ScrollToTop />
          <Layout />
        </ConfirmProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
